import { Controller } from 'react-hook-form';
import {
  ButtonPrimary,
  ButtonType,
  IconSelected,
  IconClose,
  IconLoader,
  InputPassword,
  InputText,
} from '@ui/src';
import { AuthResetPasswordTypes } from './types';

import cn from './styles.module.css';
import sharedStyles from '../shared.module.css';

const AuthResetPasswordForm = ({
  control,
  onSubmit,
  requestInProgress,
  errors,
  globalError,
  passwordValue,
  passwordIsValid,
  onValidatePassword,
  passwordValidation,
}: AuthResetPasswordTypes): React.JSX.Element => (
  <form className={sharedStyles.form} onSubmit={onSubmit}>
    <h3>Set new password</h3>
    {globalError && (
      <div className={sharedStyles.globalErrorMessage}>{globalError}</div>
    )}
    <div className={sharedStyles.formGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="email"
        render={({ field: { onChange, value } }) => (
          <InputText
            placeholder="Enter email"
            name="email"
            value={value}
            onChange={onChange}
            error={errors.email?.message}
            disabled={requestInProgress}
          />
        )}
      />
    </div>
    <div className={sharedStyles.formGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="password"
        render={({ field: { onChange, value } }) => (
          <InputPassword
            placeholder="New password"
            name="password"
            value={value}
            onChange={(e) => {
              onChange(e);
              onValidatePassword(e.target.value);
            }}
            error={errors.password?.message}
            disabled={requestInProgress}
          />
        )}
      />
    </div>
    <div className={sharedStyles.formGroup}>
      <Controller
        control={control}
        defaultValue=""
        name="verifyPassword"
        render={({ field: { onChange, value } }) => (
          <InputPassword
            placeholder="Repeat password"
            name="verifyPassword"
            value={value}
            onChange={onChange}
            error={errors.verifyPassword?.message}
            disabled={requestInProgress}
          />
        )}
      />
    </div>
    <ul className={cn.passwordValidation}>
      <li>
        {passwordValue && passwordValidation.length && (
          <div className={cn.iconWrapper}>
            <IconSelected className={cn.iconValid} width={16} height={16} />
          </div>
        )}
        {passwordValue && !passwordValidation.length && (
          <div className={cn.iconWrapper}>
            {' '}
            <IconClose className={cn.iconInvalid} width={16} height={16} />
          </div>
        )}
        8 or more characters
      </li>
      <li>
        {passwordValue && passwordValidation.hasUpper && (
          <div className={cn.iconWrapper}>
            <IconSelected className={cn.iconValid} />
          </div>
        )}
        {passwordValue && !passwordValidation.hasUpper && (
          <div className={cn.iconWrapper}>
            <IconClose className={cn.iconInvalid} width={16} height={16} />
          </div>
        )}
        at least one capital letter
      </li>
      <li>
        {passwordValue && passwordValidation.hasNumber && (
          <div className={cn.iconWrapper}>
            <IconSelected className={cn.iconValid} />
          </div>
        )}
        {passwordValue && !passwordValidation.hasNumber && (
          <div className={cn.iconWrapper}>
            <IconClose className={cn.iconInvalid} width={16} height={16} />
          </div>
        )}
        at least one number
      </li>
      <li>
        {passwordValue && passwordValidation.hasSpecialCharacter && (
          <div className={cn.iconWrapper}>
            <IconSelected className={cn.iconValid} />
          </div>
        )}
        {passwordValue && !passwordValidation.hasSpecialCharacter && (
          <div className={cn.iconWrapper}>
            <IconClose className={cn.iconInvalid} />
          </div>
        )}
        at least one special character
      </li>
    </ul>
    <div className={sharedStyles.authButtons}>
      <ButtonPrimary
        type={ButtonType.SUBMIT}
        icon={requestInProgress ? <IconLoader /> : undefined}
        text={requestInProgress ? '' : 'Next'}
        disabled={!passwordIsValid}
        bold
      />
    </div>
  </form>
);

export default AuthResetPasswordForm;
